import abi from "./contract/GlobalPool.json";
import { useState, useEffect } from "react";
import { ethers } from "ethers";
import Buy from "./component/buy";
import Buy1 from "./component/buy1";
import Buy2 from "./component/buy2";
import Buy4 from "./component/buy4";
import Buy5 from "./component/buy5";
import Buy6 from "./component/buy6";
import Memos from "./component/memos";
import "./copy.png";
import Buy3 from "./component/buy3";



function App() {
  const [state, setState] = useState({
    provider: null,
    signer: null,
    contract: null,
  });
  
  const [account, setAccount] = useState("None");
  const[b,setB]=useState("None");
  const[direct,setDirect]=useState("None");
  const[directs,setDirects]=useState("None");
  const[level,setLevel]=useState("None");
  const[wlevel,setLevelw]=useState("None");
  const[level1,setLevel1]=useState("None");
  const[wlevel1,setLevelw1]=useState("None");
  const[plevel,setLevelp]=useState("None");
  const[pack,setpackage]=useState("None");
  const[pack3,setpackage3]=useState("None");
  const[pack1,setpackage1]=useState("None");
  const[refer,setrefer]=useState("None");
  const[refer4,setrefer4]=useState("None");
  const[refer3,setrefer3]=useState("None");
  const[refer1,setrefer1]=useState("None");
  const[refer2,setrefer2]=useState("None");
const [tasks,setTasks] = useState([]);
const [tasks1,setTasks1] = useState([]);
const [tt,settt]=useState("None");
const [tt4,settt4]=useState("None");
const[dd,setDD]=useState("None");
const[dd1,setDD1]=useState("None");
const[dd2,setDD2]=useState("None");
const[referlink,setreflink]=useState("None");
const[bonanza,setBonanza]=useState("None");
const[upd,setupd]=useState("None");
const [tt1,settt1]=useState("None");
const [roi,seroi]=useState("None");
const [roi1,seroi1]=useState("None");
const [roi2,seroi2]=useState("None");
const [a1,sea1]=useState("None");
const [a2,sea2]=useState("None");
const [a3,sea3]=useState("None");
const [tt2,settt2]=useState("None");
const [tt3,settt3]=useState("None");
const[b1,setb1]=useState("None");
const[b2,setb2]=useState("None");
const[b3,setb3]=useState("None");
const[b4,setb4]=useState("None");
const[b5,setb5]=useState("None");
const[b6,setb6]=useState("None");
const[b7,setb7]=useState("None");
const[b8,setb8]=useState("None");
const[b9,setb9]=useState("None");
const[b10,setb10]=useState("None");
const[b11,setb11]=useState("None");
const[b12,setb12]=useState("None");
const[b13,setb13]=useState("None");
const[b14,setb14]=useState("None");
const[b15,setb15]=useState("None");
const[b16,setb16]=useState("None");
const[dir1,setdir1]=useState("None");
const[reward,setreward]=useState("None");
const[reward1,setreward1]=useState("None");
const[reward2,setreward2]=useState("None");
const[reward3,setreward3]=useState("None");
const[reward4,setreward4]=useState("None");
const[reward5,setreward5]=useState("None");
const[reward6,setreward6]=useState("None");
const[reward7,setreward7]=useState("None");
const[reward8,setreward8]=useState("None");
const[reward9,setreward9]=useState("None");
const[reward10,setreward10]=useState("None");

const[x1,setx1]=useState("None");
const[x2,setx2]=useState("None");
const[x3,setx3]=useState("None");
const[x4,setx4]=useState("None");
const[x5,setx5]=useState("None");

const[x11,setx11]=useState("None");
const[x12,setx12]=useState("None");
const[x13,setx13]=useState("None");
const[x14,setx14]=useState("None");
const[x15,setx15]=useState("None");

  useEffect(() => {
    
    const connectWallet = async () => {
      
      const contractAddress = "0xE62033615dD9C6e90959e790d128e9A2533b4BCf";
      const contractABI = abi.abi;
      const searchParams = new URLSearchParams(window.location.search);
    const myParam = searchParams.get('ref');
    console.log(myParam);
    document.querySelector("#name").value=myParam;
if(myParam == null)
  {
    document.querySelector("#name").value="0x9B395f94ad743df207e802A0d759CC78aaF31f7b";
  }
  
  try {
    const { ethereum } = window;
  //  document.querySelector("#test").value = "0";
    if (ethereum) {
      const account = await ethereum.request({
        method: "eth_requestAccounts",
       
      });
     
      window.ethereum.on("chainChanged", () => {
        window.location.reload();
      });

      window.ethereum.on("accountsChanged", () => {
        
        window.location.reload();
      });
          const provider = new ethers.providers.Web3Provider(ethereum);
        
          try {
            const selectedNetwork = await provider.getNetwork();
          
            if (selectedNetwork.chainId !== 56) {
              await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: '0x38' }], // Binance Smart Chain Mainnet chainId is 97 in decimal, which is 0x61 in hex
              });
              console.log("You have switched to the Binance network");
            } else {
              console.log("You are already on the Binance network");
            }
          } catch (switchError) {
            // The network has not been added to MetaMask
            if (switchError.code === 4902) {
              console.log("Please add the Binance network to MetaMask");
            } else {
              console.log("Cannot switch to the network");
            }
          }
        
        
        
          const signer = provider.getSigner();
          const contract = new ethers.Contract(
            contractAddress,
            contractABI,
            signer
          );
          setAccount(account);
          setState({ provider, signer, contract });
          document.querySelector("#us").value  = account[0];
      let alltasks = await contract.getMemos(account[0]);
      setTasks(alltasks);
      var i = 0;
      const refer = (alltasks[1]);
      setrefer(refer);
      const a1 = Number(alltasks[0]);
      sea1(a1);
      const refer2 = (alltasks[23]);
     setrefer2(refer2);
	 const dir1 = Number(alltasks[22]);
     setdir1(dir1);
      const b =Number(alltasks[2]);
     

     document.querySelector("#hid").value  = (alltasks[1]);
     document.querySelector("#direct").value  = (alltasks[2]);
     document.querySelector("#level").value  = (alltasks[4]);
     document.querySelector("#wid").value  = (alltasks[32])/1000000000000000000;
     const direct =Number(alltasks[2]);
     setDirect(direct);
     const level = Number(alltasks[4]);
     setLevel(level);


     const plevel = Number(alltasks[21])/1000000000000000000;
     setLevelp(plevel);
     
    
     const pack = Number(alltasks[3]) ;

setpackage(pack);

document.querySelector("#pp").value  = Number(alltasks[3]);




     setB(b);

     

     const dd = Number(alltasks[9]);
          
     setDD(dd);

     const reward1 = Number(alltasks[11])/1000000000000000000;
          
     setreward1(reward1);
     
     const reward2 = Number(alltasks[17])/1000000000000000000;
          
     setreward2(reward2);
     const reward3 = Number(alltasks[18])/1000000000000000000;
          
     setreward3(reward3);
	   
	 	
								
	
      const reward4 =  Number(alltasks[23])/1000000000000000000;
      setreward4(reward4);
      const reward5 =  Number(alltasks[27]);
      setreward5(reward5);




      const reward6 =  Number(alltasks[28]);
      setreward6(reward6);

      const reward7 =  Number(alltasks[29]);
      setreward7(reward7);


     const x1 = Number(alltasks[17])/1000000000000000000;
     setx1(x1);
     const x2 = Number(alltasks[18])/1000000000000000000;
     setx2(x2);
     const x3 = Number(alltasks[19])/1000000000000000000;
     setx3(x3);


     const x11 = Number(alltasks[23]);
     setx11(x11); 
     const x12 = Number(alltasks[28]);
     setx12(x12);
     const x13 = Number(alltasks[31]);
     setx13(x13);

     const x14 = Number(alltasks[29]);
     setx14(x14);


     const x15 = Number(alltasks[28])/1000000000000000000;
     setx15(x15);
    
    
     


     const dd2 = Number(alltasks[26]);
          
     setDD2(dd2);

     const dd1 =  Date.now() / 1000;
     setDD1(dd1);


     const tt1 = Math.trunc((dd1 - dd) / (3660 * 24 )) ;
   //  const tt1 =  (dd1.getTime() - dd.getTime())/ (1000 * 60 * 60 * 24);
     
     settt1(tt1);

       
       const b1 = Number(alltasks[5]) ;
       setb1(b1);
       const b2 = Number(alltasks[6]) ;
       setb2(b2);
       const b3 = Number(alltasks[7]) ;
       setb3(b3);
       const b4 = Number(alltasks[8]) ;
       setb4(b4);
       const b5 = Number(alltasks[9]) ;
       setb5(b5);
       const b6 = Number(alltasks[10]) ;
       setb6(b6);
       const b7 = Number(alltasks[24]) ;
       setb7(b7);
     
	   const wlevel = Number(alltasks[25])/1000000000000000000 ;
          
 setLevelw(wlevel);
 const wlevel1 = Number(alltasks[15])/1000000000000000000;
          
 setLevelw1(wlevel1);
 const level1 = Number(alltasks[21]);
          
 setLevel1(level1);
 

    // document.querySelector("#wi1").value = roi2;
     
    // const a1 = Number(alltasks1[0])-1;
          
    // sea1(a1);
    // const a3 = Number(alltasks1[2])/1000000000000000000;
          
   //  sea3(a3);
     const a2 = Number(alltasks[24]);
    sea2(a2);   
     var rr = 0;
    // const tt4 =  Number(alltasks[15])/1000000000000000000;
    // settt4(tt4);
     
const pack1 = Number(alltasks[22])/1000000000000000000;
setpackage1(pack1);
     const tt =  Number(alltasks[16])/1000000000000000000;
     settt(tt);
     const tt3 = Number(alltasks[10])/1000000000000000000;
     settt3(tt3);
     document.querySelector("#bal").value = tt3;
     const referlink = 'https://agipay24.world/?ref='+ account;
     setreflink(referlink);
     document.querySelector("#link").value =referlink;


     const upd = b1+b2+b3+b4+b5+b6+b7+b8+b9+b10+b11+b12+b13+b14+b15;
          
     setupd(upd);


console.log(pack);

const tt2 = 1440 - Math.trunc((dd1 - dd2)/60) ;
       
       settt2(tt2);

      if(tt2<0)
      {
        const tt2 = 0;
       
       settt2(tt2);
        const x5 = "Next Trade Pending" ;
       setx5(x5);
      }
      else
      {
         const x5 = "Trade Already Claimed" ;
       setx5(x5);
      }

       document.querySelector("#tt2").value = tt2;
     


 
        } else {
          alert("Please install metamask");
        }
      } catch (error) {
        console.log(error);
      }
    };
    
   
    
    connectWallet();
    
    function myFunction() {
      
      var copyText = "hello";
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices
      
    
      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.valueOf);
    }

  }, []);

 
  // console.log(state);
  return (
  <div>
    <input type="hidden" id ="link"></input>
    <input type="hidden" id ="hid"></input>
    <input type="hidden" id ="us"></input>
    <input type="hidden" id ="pp"></input>
    <input type="hidden" id ="tt2"></input>
    <input type="hidden" id ="wi1"></input>
    <input type="hidden" id ="roi"></input>
    <input type="hidden" id ="bal"></input>
    <input type="hidden" id ="direct"></input>
    <input type="hidden" id ="level"></input>
    <input type="hidden" id ="wid"></input>
      <section
          class="gradient-bg our-services service-bg-three pt-95 pb-55 pt-lg-55 pb-lg-15"
        >
          <img
            class="service-shape-3c"
            src="img/shape/line-round-6b.svg"
            alt="shape"
          />
          <div class="container">
            
            <div class="row gx-4 gx-xxl-5">
              <div class="col-lg-4 col-md-6" >
                <div class="feature-style-five mb-45">
                  <div class="icon mb-30">
                    <img src="img/icon/bitcoin.png" alt="icon" />
                  </div>
                  <h2 style={{color:"white"}}  class="mb-20">
                    Register
                  </h2>
                  <p>
                   <input style={{
    width: "80%",
    maxWidth: "200px",
    margin: "2px auto",
    textAlign: "center",
    padding: "4px",
    borderRadius: "6px",
    border: "none",
    outline: "none"
  }}  type="text" id ="amt"  width={"200px"} ></input> 
                  </p>
                  <p><Buy state={state}  /></p>

                
                </div>
              </div>
             
              <div class="col-lg-4 col-md-6" >
                <div class="feature-style-five mb-45">
                  <div class="icon mb-30">
                    <img src="img/icon/2.png" alt="icon" />
                  </div>
                  <h2 style={{color:"white"}}  class="mb-20">
                   Withdraw
                  </h2>
                  <p>
                   <input style={{
    width: "80%",
    maxWidth: "200px",
    margin: "2px auto",
    textAlign: "center",
    padding: "4px",
    borderRadius: "6px",
    border: "none",
    outline: "none"
  }}  type="text" id ="test"  width={"200px"}></input>  
                  </p>
                  <br></br>
                  <p><Buy3 state={state}  /></p>
                </div>
              </div>
              
               <div class="col-lg-4 col-md-6" >
                <div class="feature-style-five mb-45">
                  <div class="icon mb-30">
                    <img src="img/icon/deposit.png" alt="icon" />
                  </div>
                  <h2 style={{color:"white"}}  class="mb-20">
                   Trade 
                  </h2>
                  <p>
                   <Buy1 state={state}  />  
                  </p>
                  <p></p>
                </div>
              </div>
               <div class="col-lg-4 col-md-6" >
                <div class="feature-style-five mb-45">
                  <div class="icon mb-30">
                    <img src="img/icon/5.png" alt="icon" />
                  </div>
                  <h2 style={{color:"white"}}  class="mb-20">
                   Trade 
                  </h2>
                  <p>
                   Next Trade In : {tt2} Minutes   
                  </p>
                  <p> {x5}</p>
                </div>
              </div>
                <div class="col-lg-4 col-md-6" >
                <div class="feature-style-five mb-45">
                  <div class="icon mb-30">
                    <img src="img/icon/deposit.png" alt="icon" />
                  </div>
                  <h2 style={{color:"white"}}  class="mb-20">
                    Total Deposit
                  </h2>
                  <p>
                    {pack} USDT 
                  </p>
                  
                </div>
              </div>
              <div class="col-lg-4 col-md-6" >
                <div class="feature-style-five mb-45">
                  <div class="icon mb-30">
                    <img src="img/icon/bitcoin.png" alt="icon" />
                  </div>
                  <h2 style={{color:"white"}}  class="mb-20">
                   Principle Pending
                  </h2>
                  <p>
                     {pack1} USDT   
                  </p>
                  <p> </p>
                </div>
              </div>
              <div class="col-lg-4 col-md-6" >
                <div class="feature-style-five mb-45">
                  <div class="icon mb-30">
                    <img src="img/icon/bitcoin.png" alt="icon" />
                  </div>
                  <h2 style={{color:"white"}}  class="mb-20">
                   Total Income
                  </h2>
                  <p>
                     {tt} USDT   
                  </p>
                  <p> </p>
                </div>
              </div>
                <div class="col-lg-4 col-md-6" >
                <div class="feature-style-five mb-45">
                  <div class="icon mb-30">
                    <img src="img/icon/bitcoin.png" alt="icon" />
                  </div>
                  <h2 style={{color:"white"}}  class="mb-20">
                   Pending Withdraw
                  </h2>
                  <p>
                     {tt - wlevel1} USDT   
                  </p>
                  <p> </p>
                </div>
              </div>
              
                <div class="col-lg-4 col-md-6" >
                <div class="feature-style-five mb-45">
                  <div class="icon mb-30">
                    <img src="img/icon/digital.png" alt="icon" />
                  </div>
                  <h2 style={{color:"white"}}  class="mb-20">
                   Direct Team 
                  </h2>
                  <p>
                     {direct}  
                  </p>
                  <p> </p>
                </div>
              </div>
                <div class="col-lg-4 col-md-6" >
                <div class="feature-style-five mb-45">
                  <div class="icon mb-30">
                    <img src="img/icon/bitcoin-trading-app.png" alt="icon" />
                  </div>
                  <h2 style={{color:"white"}}  class="mb-20">
                   Level Team
                  </h2>
                  <p>
                    {level}     
                  </p>
                  <p> </p>
                </div>
              </div>
                <div class="col-lg-4 col-md-6" >
                <div class="feature-style-five mb-45">
                  <div class="icon mb-30">
                    <img src="img/icon/cryptocurrecncy.png" alt="icon" />
                  </div>
                  <h2 style={{color:"white"}}  class="mb-20">
                   Team Business
                  </h2>
                  <p>
                     {level1} 
                  </p>
                  <p> </p>
                </div>
              </div>
                <div class="col-lg-4 col-md-6" >
                <div class="feature-style-five mb-45">
                  <div class="icon mb-30">
                    <img src="img/icon/5.png" alt="icon" />
                  </div>
                  <h2 style={{color:"white"}}  class="mb-20">
                   Total Team
                  </h2>
                  <p>
                     {level + direct}  
                  </p>
                  <p> </p>
                </div>
              </div>
                <div class="col-lg-4 col-md-6" >
                <div class="feature-style-five mb-45">
                  <div class="icon mb-30">
                    <img src="img/icon/deposit.png" alt="icon" />
                  </div>
                  <h2 style={{color:"white"}}  class="mb-20">
                    Revenue Share
                  </h2>
                  <p>
                    {x1} 
                  </p>
                  <p> </p>
                </div>
              </div>
                <div class="col-lg-4 col-md-6" >
                <div class="feature-style-five mb-45">
                  <div class="icon mb-30">
                    <img src="img/icon/6.png" alt="icon" />
                  </div>
                  <h2 style={{color:"white"}}  class="mb-20">
                   Direct Bonus 
                  </h2>
                  <p>
                     {x2} USDT
                  </p>
                  <p> </p>
                </div>
              </div>
                <div class="col-lg-4 col-md-6" >
                <div class="feature-style-five mb-45">
                  <div class="icon mb-30">
                    <img src="img/icon/7.png" alt="icon" />
                  </div>
                  <h2 style={{color:"white"}}  class="mb-20">
                   Level Bonus
                  </h2>
                  <p>
                     {x3} USDT  
                  </p>
                  <p> </p>
                </div>
              </div>
                <div class="col-lg-4 col-md-6" >
                <div class="feature-style-five mb-45">
                  <div class="icon mb-30">
                    <img src="img/icon/8.png" alt="icon" />
                  </div>
                  <h2 style={{color:"white"}}  class="mb-20">
                   Fast Track Royalty 
                  </h2>
                  <p>
                    {x15} USDT  
                  </p>
                  <p> </p>
                </div>
              </div>
               
                <div class="col-lg-4 col-md-6" >
                <div class="feature-style-five mb-45">
                  <div class="icon mb-30">
                    <img src="img/icon/2.png" alt="icon" />
                  </div>
                  <h2 style={{color:"white"}}  class="mb-20">
                    TOTAL WITHDRAWL
                  </h2>
                  <p>
                     {wlevel1}  USDT  
                  </p>
                  <p> </p>
                </div>
              </div>
                <div class="col-lg-4 col-md-6" >
                <div class="feature-style-five mb-45">
                  <div class="icon mb-30">
                    <img src="img/icon/digital.png" alt="icon" />
                  </div>
                  <h2 style={{color:"white"}}  class="mb-20">
                   Level 1 Business
                  </h2>
                  <p>
                     {b1}  USDT 
                  </p>
                  <p> </p>
                </div>
              </div>
                <div class="col-lg-4 col-md-6" >
                <div class="feature-style-five mb-45">
                  <div class="icon mb-30">
                    <img src="img/icon/deposit.png" alt="icon" />
                  </div>
                  <h2 style={{color:"white"}}  class="mb-20">
                   Level 2 Business
                  </h2>
                  <p>
                    {b2}  USDT  
                  </p>
                  <p> </p>
                </div>
              </div>
                <div class="col-lg-4 col-md-6" >
                <div class="feature-style-five mb-45">
                  <div class="icon mb-30">
                    <img src="img/icon/graph.png" alt="icon" />
                  </div>
                  <h2 style={{color:"white"}}  class="mb-20">
                   Level 3 Business
                  </h2>
                  <p>
                      {b3}  USDT 
                  </p>
                  <p> </p>
                </div>
              </div>
                <div class="col-lg-4 col-md-6" >
                <div class="feature-style-five mb-45">
                  <div class="icon mb-30">
                    <img src="img/icon/4.png" alt="icon" />
                  </div>
                  <h2 style={{color:"white"}}  class="mb-20">
                    Level 4 Business
                  </h2>
                  <p>
                      {b4}  USDT 
                  </p>
                  <p> </p>
                </div>
              </div>
                <div class="col-lg-4 col-md-6" >
                <div class="feature-style-five mb-45">
                  <div class="icon mb-30">
                    <img src="img/icon/5.png" alt="icon" />
                  </div>
                  <h2 style={{color:"white"}}  class="mb-20">
                   Level 5 Business
                  </h2>
                  <p>
                    {b5}  USDT 
                  </p>
                  <p> </p>
                </div>
              </div>
             
                <div class="col-lg-4 col-md-6" >
                <div class="feature-style-five mb-45">
                  <div class="icon mb-30">
                    <img src="img/icon/8.png" alt="icon" />
                  </div>
                  <h2 style={{color:"white"}}  class="mb-20">
                   Referlink
                  </h2>
                  <p>
                     {referlink} <a href="#">
       <button><img src ="copy.png" width={"15px"} onClick={() => {
         navigator.clipboard.writeText(referlink);}} /></button> </a> USDT  
                  </p>
                  <p> </p>
                </div>
              </div>
                <div class="col-lg-4 col-md-6" >
                <div class="feature-style-five mb-45">
                  <div class="icon mb-30">
                    <img src="img/icon/deposit.png" alt="icon" />
                  </div>
                  <h2 style={{color:"white"}}  class="mb-20">
                   My Account
                  </h2>
                  <p>
                     {account} 
                  </p>
                  <p> </p>
                </div>
              </div>
                
              
              </div>
              </div>
              </section>



   

     

     
     
    <br></br>

   </div>

  );
}

export default App;